export default "__VITE_ASSET__R9CF9e2g__"